import {Role} from "dto/Role"
import {useCallback, useMemo, useState} from "react"

type SelectBoxProps = {
    items: Role[]
    onChangeItem?: (item: Role) => void
    themeColor?: "blue" | "green" | "red"
}

const SelectBoxBorderColors = {
    blue: "border-blue-600",
    green: "border-green-600",
    red: "border-red-600"
}

const SelectBoxBgColors = {
    blue: "bg-blue-100",
    green: "bg-green-100",
    red: "bg-red-100"
}

const SelectBoxHoverColors = {
    blue: "hover:bg-blue-50",
    green: "hover:bg-green-50",
    red: "hover:bg-red-50"
}

export function SelectBox({items = [], onChangeItem, themeColor = "red"}: SelectBoxProps) {
    const [selectedItem, setSelectedItem] = useState<Role | undefined>()

    const selectItem = useCallback((item: Role) => {
        setSelectedItem(item)
        if (onChangeItem) {
            onChangeItem(item)
        }
    }, [onChangeItem])
    const containerStyle = useMemo(() => `${SelectBoxBorderColors[themeColor]} border rounded-md pt-3 pb-3 pl-2 pr-2 overflow-hidden overflow-y-auto h-56`, [themeColor])
    // const containerStyle = `border-green-600 border rounded-md pt-3 pb-3 pl-2 pr-2 overflow-hidden overflow-y-auto h-56`
    const selectItemStyle = (name: string) => {
        return `cursor-pointer scroll-smooth p-2 pl-5 pr-5 border-b ${selectedItem?.name === name ? SelectBoxBgColors[themeColor] : SelectBoxHoverColors[themeColor]}`
        // return `cursor-pointer scroll-smooth p-2 pl-5 pr-5 border-b ${selectedItem?.name === name ? `bg-green-100` : `hover:bg-green-50`}`
    }
    return (
        <div className={containerStyle}>
            {items?.map(role => {
                const itemStyle = selectItemStyle(role.name)
                return (
                    <div className={itemStyle} onClick={() => selectItem(role)} key={role.name}>
                        {role.name}
                    </div>
                )
            })}
        </div>
    )
}